import { Percent } from '@phosphor-icons/react';

export default Percent;
